import { useKeycloak } from "@react-keycloak/web";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useFetchCompteQuery, useUpdateCompteMutation } from "../../../redux/slice/api/FO/compteApi";
import { SubmitHandler } from "react-hook-form";

import { IFormUtilisateur } from "../../../models/interfaces/IFormUtilisateur";

import { toast } from "react-toastify";
import UtilisateurInformationsPersonnel from "./UtilisateurInformationsPersonnel";
import { ICompte } from "../../../models/interfaces/ICompte";
import { Tab, Tabs } from "react-bootstrap";
import FOCompteSocieteTabMarques from "../../BO/components/FOCompteSocieteTabMarques";
import FOCompteSocieteTabActeursJuridiques from "../../BO/components/FOCompteSocieteTabActeursJuridiques";
import FOCompteSocieteTabFond from "../../BO/components/FOCompteSocieteTabFond";


const PageUtilisateurModif: React.FC = () => {

  let { Id } = useParams();
  Id = Id ?? "";
  const { initialized: keycloakinitialized,keycloak } = useKeycloak();
  const [compte,setCompte] = useState<ICompte|undefined>(undefined);
  // const [IdCiviliteValue,setIdCiviliteValue] = useState<number|undefined>(undefined);
  // const [IdTypeCompteValue,setIdTypeCompteValue] = useState<number|undefined>(undefined);
  const [NomPrenom, setNomPrenom] = useState("");

  // Active Tabs 
  const [currTabName, setcurrTabName] = useState("infos");

  const { data: CompteResult,refetch: Compterefetch} = useFetchCompteQuery(Id, {
    refetchOnMountOrArgChange: true,
    skip: !keycloakinitialized || !keycloak.authenticated || Id === "",
  });

  const [
    updateCompte,
    {
    isSuccess: isSuccessUpdateCompte,
    error: errorUpdateCompte,
  }] = useUpdateCompteMutation();

useEffect(() => {
  if (CompteResult?.Compte) {
    setCompte(CompteResult?.Compte);
  }

}, [CompteResult])



useEffect(() => {
  if (errorUpdateCompte !== undefined) {
    toast.warn("Les modifications n'ont pas été prises en compte");
    //setUpdateError(errorUpdateBO)
  }
}, [errorUpdateCompte])

useEffect(() => {
  if (isSuccessUpdateCompte) {
    toast.success("Les modifications ont bien été prises en compte.");
    Compterefetch();
    // setPublication(publication);
    // setUpdateSuccess(true);
  }
}, [isSuccessUpdateCompte])

  const onSubmitUtilisateur: SubmitHandler<IFormUtilisateur> = (data) => {
    updateCompte(
      {
        ...data,
        Id:Id ? parseInt(Id) : -1,
        Login:data.Email,
      }
    );
  };

  return (
  <>
   <div className="container text-center">
        <div className="row pt-3 pb-2">
          <div className="col col-12 ">
            <h2 className="titreModule titre-bleu"><i className="bi-person pe-2" />Utilisateur ({NomPrenom})</h2>
          </div>
        </div>
        <div className="row pt-3 pb-5">
          <div className="col col-md-10 offset-md-1 col-12 ">
    {compte && 
      <Tabs defaultActiveKey={currTabName} id="uncontrolled-tab-example" onSelect={(key) => setcurrTabName(key ?? "infos")} className="onglet mb-3">
        <Tab eventKey="infos" title="Informations générales">
          <UtilisateurInformationsPersonnel Compte={compte} disableEmail={true} handleEnregistrer={onSubmitUtilisateur} ReadOnlyServicePart={false} setCompte={setCompte} handleNomPrenom={setNomPrenom} />
        </Tab>
        <Tab eventKey="marques" title="Affectation par marques" >
          <FOCompteSocieteTabMarques IdCompte={parseInt(Id)} refetch={currTabName === "marques"}></FOCompteSocieteTabMarques>
        </Tab>
        <Tab eventKey="societes" title="Affectation par sociétés" >
          <FOCompteSocieteTabActeursJuridiques IdCompte={parseInt(Id)} refetch={currTabName === "societes"}></FOCompteSocieteTabActeursJuridiques>
        </Tab>
        <Tab eventKey="fondtotal" title="Affectation totale" >
          <FOCompteSocieteTabFond IdCompte={parseInt(Id)} refetch={currTabName === "fondtotal"}></FOCompteSocieteTabFond>
        </Tab>
      </Tabs>
    }
      </div>
           </div>
           </div>
  </>
  )

}; 

export default PageUtilisateurModif;

